module.exports = __webpack_public_path__ + "img/08.f20f72b9.jpg";